var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fade',[(_vm.visible)?_c('div',{staticClass:"overlay is-overlay",class:{ 'is-opaque': !_vm.transparent }},[_c('div',{class:['loader', `is-${_vm.size}`],style:(_vm.borderColor)})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }